/**
 * The onboarding card step's server calls (SC-438). See `server/routes/onboardingBilling.ts`.
 * Both need a signed-in admin of the company.
 */
import Parse from './initializeParse'
import { getServerBaseUrl } from '../utils/serverUrl'
import { getStoredSessionToken } from '../utils/sessionToken'
import { forbiddenText } from '../utils/rbacMessages'

const FALLBACK_ERROR = 'Billing could not be set up. Try again.'

async function post<T>(path: string, body: Record<string, unknown>): Promise<T> {
  const token = getStoredSessionToken() || Parse.User.current()?.getSessionToken() || ''
  const response = await fetch(`${getServerBaseUrl()}/api/onboarding/billing/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok || !data?.success) {
    throw Object.assign(new Error(forbiddenText(response.status, data) ?? (data?.error || FALLBACK_ERROR)), { status: response.status })
  }
  return data as T
}

/** A SetupIntent for the card form. Nothing is charged. */
export function createOnboardingSetupIntent(companyId: string) {
  return post<{ clientSecret: string; setupIntentId?: string }>('setup-intent', { companyId })
}

/** Starts the 30-day trial on the card the SetupIntent saved. */
export function startOnboardingTrial(companyId: string, setupIntentId: string) {
  return post<{ trialEndsAt: string | null; alreadyStarted?: boolean }>('start-trial', { companyId, setupIntentId })
}
